import React from 'react';
import { useTranslation } from 'react-i18next';

import HomeHiddenOpportunitiesSection from '../components/HomePage/sections/HomeHiddenOpportunitiesSection';
import MarketingPageShell from '../components/marketing/MarketingPageShell';

interface FeatureSmartMatchingPageProps {
  onNavigate?: (view: string) => void;
}

const FeatureSmartMatchingPage: React.FC<FeatureSmartMatchingPageProps> = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <MarketingPageShell
      onNavigate={onNavigate}
      activeView="feature-smart-matching"
      title={t('pages.smartMatching.seoTitle', 'Smart Job Matching | GoGrabJob')}
      description={t(
        'pages.smartMatching.seoDescription',
        'Discover high-fit roles your job title would never surface — semantic AI matching beyond keyword search.',
      )}
      canonical="https://www.gograbjob.com/features/smart-matching"
    >
      <HomeHiddenOpportunitiesSection onNavigate={onNavigate} />
    </MarketingPageShell>
  );
};

export default FeatureSmartMatchingPage;
